import { __awaiter } from "tslib";
import { formatOptionUsage } from './terminal_buffer';
const commandOptions = {
    a: {
        longName: 'alias',
        description: 'Delete system with alias.',
        valueName: 'name',
        valueRequired: true,
    },
    all: {
        description: 'Delete all systems.',
    },
    i: {
        longName: 'pid',
        description: 'Delete a proof.',
        valueName: 'proofId',
        valueRequired: true,
    },
    p: {
        longName: 'proofOnly',
        description: 'Only delete the proofs of specified systems.',
    },
};
const logUsage = (buf, msg = '') => __awaiter(void 0, void 0, void 0, function* () {
    let texts = [];
    if (msg) {
        if (typeof msg === 'string') {
            texts.push({ text: msg });
        }
        else {
            texts = texts.concat(msg);
        }
    }
    texts = texts.concat([
        { text: 'usage: delete [<alias>] [<option>]' },
        { text: '' },
        { text: 'Options:' },
        ...Object.keys(commandOptions)
            .map(name => formatOptionUsage(name, commandOptions[name]))
            .map(text => ({ text })),
        { text: '' },
        { text: 'When a system is deleted, all of its proofs will be deleted, too.' },
        { text: '' },
    ]);
    yield buf.log(texts);
});
const run = (buf, app) => __awaiter(void 0, void 0, void 0, function* () {
    const { argv, options } = buf;
    if (options.i) {
        const pidInput = options.i;
        const pid = pidInput.replace(/^0x/, '');
        const proof = yield app.getProof(pid);
        if (!proof) {
            yield buf.log([{ text: `Proof not found. Proof id: ${pidInput}.`, color: 'red' }]);
            return;
        }
        yield app.deleteProof(pid);
        yield buf.log([{ text: `Successfully deleted proof '${pidInput}'.`, color: 'green' }]);
        return;
    }
    const [, v1] = argv;
    const alias = v1 && !v1.startsWith('-') ? v1 : options.a;
    if (!alias && !options.all) {
        yield logUsage(buf, [{ text: 'Too few arguments.', color: 'red' }]);
        return;
    }
    const proofOnly = options.p === true;
    if (options.all) {
        if (proofOnly) {
            const confirmed = yield buf.confirm('Are you sure you want to delete all the proofs?');
            if (confirmed) {
                yield app.deleteAllProofs();
                yield buf.log([{ text: 'Successfully deleted all proofs.', color: 'green' }]);
            }
            return;
        }
        const confirmed = yield buf.confirm('Are you sure you want to delete all the systems and their proofs?');
        if (confirmed) {
            yield app.deleteAllComposers();
            yield buf.log([{ text: 'Successfully deleted all systems.', color: 'green' }]);
        }
        return;
    }
    const composer = yield app.getComposerWithAlias(alias);
    if (!composer) {
        yield buf.log([{ text: `System not found. Alias: ${alias}.`, color: 'red' }]);
        return;
    }
    if (proofOnly) {
        const confirmed = yield buf.confirm(`Are you sure you want to delete all the proofs for system '${alias}'?`);
        if (confirmed) {
            yield app.deleteProofsOfComposer(composer.id);
            yield buf.log([{ text: `Successfully deleted all proofs for system '${alias}'.`, color: 'green' }]);
        }
        return;
    }
    const confirmed = yield buf.confirm(`Are you sure you want to delete system '${alias}'?`);
    if (confirmed) {
        yield app.deleteComposer(alias);
        yield buf.log([{ text: `Successfully deleted system '${alias}'.`, color: 'green' }]);
    }
});
export const deleteComposer = {
    run,
    logUsage,
    commandOptions,
};
//# sourceMappingURL=data:application/json;base64,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